/**
 * @fileoverview
 * Validations is a utility file for validate each poll field on submit.
 * It aims to keep the `inputStatus` state always updated according
 * to values entered by the user.
 * @see {PollCreation}
 */
import { OPTION_NOT_REQUIRED } from "./constants";
import type { IStatus } from "./interfaces";
import type { IPollCreation } from "~contexts/Socket/interfaces";

export const validateImage = (
  imageId: number,
  setStatus: (value: IStatus[]) => void,
  status: IStatus[]
) => {
  const updatedStatus = status.map((input) => {
    if (input.type === "option" && input.id === imageId) {
      return { ...input, isImageInvalid: true };
    }

    return input;
  });

  setStatus(updatedStatus);
};

export const validateQuestion = (
  setStatus: (value: IStatus[]) => void,
  status: IStatus[]
) => {
  const updatedStatus = status.map((input) => {
    if (input.type === "question") {
      return { ...input, isInvalid: true };
    }

    return input;
  });

  setStatus(updatedStatus);
};

export const validateOptions = (
  status: IStatus[],
  setStatus: (value: IStatus[]) => void,
  pollCreation: IPollCreation
) => {
  const { question } = pollCreation;
  const updatedStatus = status.map((input) => {
    if (input.type === "option" && input.id !== OPTION_NOT_REQUIRED) {
      return { ...input, isInvalid: !pollCreation[`option${input.id}`] };
    }

    // if question already exists then remove red border from the field
    if (input.type === "question" && question) {
      return { ...input, isInvalid: false };
    }

    return input;
  });

  setStatus(updatedStatus);
  return;
};
